import React, { useState, useEffect } from 'react';
import { Document, Page } from 'react-pdf';
import moment from 'moment';
import {
  Grid,
  TextField,
    DialogContent,
    CircularProgress
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import MobileDetect from 'mobile-detect'

import Button from '../Button'
import VisitInformation from '../VisitInformation';
import PDFSingleViewer from '../PDFSingleViewer';
import ImgSingleViewer from '../ImgSingleViewer';
import { makeS3BlobsRenderable } from '../../util/fileHandling'
import { fetchConsultNoteAttachments } from '../../services/api'

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};

function ApptReqPreview(props) {
  const {
    appointment,
    classes: {
      root,
      visitInfo,
      confirmationFields,
      confirmationCardAppointmentSection,
      confirmationCardAppointmentSectionTitle,
      confirmationCardAppointmentSectionText,
      notes,
      previewImg,
      btnSpacing, 
      customFloatLeft,
      loading
    },
  } = props;

  const [images, setImages] = useState([]);
  const [currentPDF, setCurrentPDF] = useState([]);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [currentImg, setCurrentImg] = useState('');
  const [openImgModal, setOpenImgModal] = useState(false);

  const { patient, startTimestamp, toProvider: withProvider } = appointment;
  let withProviderTitle = withProvider.name;
  if (withProvider.fullTitle) {
    withProviderTitle = `${withProvider.fullTitle} ${withProvider.name}`;
  }
  const tenancy = withProvider.tenancy || {};
  const appointmentStart = moment(startTimestamp);

  const md = new MobileDetect(window.navigator.userAgent);
  const isMobile = md.mobile()

  useEffect(() => {
    (async () => {
      // attaching documents for upload
      const apiResponse = await fetchConsultNoteAttachments(appointment.id);

      const imageObjects = makeS3BlobsRenderable(apiResponse.data);

      setImages(imageObjects);
    })();
  }, []);

  const handleOpenImg = link => {
    setOpenImgModal(true);
    setCurrentImg(link);
  };

  const handleOpenPDF = link => {
    setOpenPDFModal(true);
    setCurrentPDF(link);
  };


  return (
    <Grid container spacing={8} className={root}>
     
      <Grid item xs={12} sm={4} className={visitInfo}>
        <VisitInformation
          provider={withProvider}
          tenancy={tenancy}
          appointmentTime={appointmentStart}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <div className={confirmationFields}>
          <div className={confirmationCardAppointmentSection}>
            <h4 className={confirmationCardAppointmentSectionTitle}>
              Patient
              </h4>
            <span
              className={confirmationCardAppointmentSectionText}
            >
              {patient.name}
            </span>
          </div>

          <div className={confirmationCardAppointmentSection}>
            <h4 className={confirmationCardAppointmentSectionTitle}>
              Provider
              </h4>
            <span
              className={confirmationCardAppointmentSectionText}
            >
              {withProviderTitle}
            </span>
          </div>

          <div className={confirmationCardAppointmentSection}>
            <h4 className={confirmationCardAppointmentSectionTitle}>
            </h4>
            <TextField
              inputProps={{
                disabled: true,
              }}
              multiline
              variant="outlined"
              name="portalNotes"
              helperText="These will not be visible to the patient."
              rows="4"
              value={appointment.body}
              className={notes}
            />
          </div>
          <div className="attachmentView">
          <DialogContent className="paddingZeroMain">
            {images &&
              images.length == 0 ?

              <div className={props.classes.loading}><CircularProgress /></div>:
              images.map((image, index) => image ?.fileType === 'pdf' ? (
                <>
                  <div className={btnSpacing} >
                    <span>{index + 1 + '.'}</span> &nbsp;&nbsp;
                                                <Button
                      color="primary"
                      disabled={image ?.fileType === 'htm' || image ?.fileType === 'html;base6' }
                      variant="contained"
                    //    onClick={() => handleOpenPDF(image.dataUrl)}
                    >
                      Pdf File
                        </Button><div>To see full report, please click download button</div>
                    <a
                      className="custom-popup-download-btn" target='_blank'
                      href={image && image.dataUrl} download >
                      Download PDF
                        </a>
                  </div>
                  <PDFSingleViewer
                    openPDFModal={openPDFModal}
                    currentPDF={currentPDF}
                    onClose={() => setOpenPDFModal(false)}
                  />
                </>
              ) : (
                  <Grid container className={customFloatLeft} item xs={6}>

                    <Grid className={btnSpacing} item xs={12}>
                      <span>{index + 1 + '.'}</span> &nbsp;&nbsp;
                                                    <Button
                        color="primary"
                        // disabled={image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6'}
                        variant="contained"
                        onClick={image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6' ? null :
                          () => handleOpenImg(image.dataUrl)}
                      >
                        {image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6' ?
                          "Html File" : "   Click to enlarge"}

                      </Button>
                      {/* <Button
                                                            color="primary"
                                                            disabled={image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6' }
                                                            variant="contained"
                                                            onClick={() => handleOpenImg(image.dataUrl)}
                                                        >
                                                            Click to enlarge
                                                            </Button> */}
                      {
                        image ?.fileType === 'htm' ||
                          image ?.fileType === 'html' || image ?.fileType === 'html;base6' ?
                            <div>To see full report, please click download button</div> :
                            <img src={image && image.dataUrl} key={`picture-${index}`} className={previewImg} />
                        }

                      <a
                        className="custom-popup-download-btn" target='_blank'
                        href={image && image.dataUrl} download >
                          {
                            image ?.fileType === 'htm' ||
                            image ?.fileType === 'html' || image ?.fileType === 'html;base6' ? 'DOWNLOAD HTML' : 'DOWNLOAD IMAGES'
                          }
                        </a>

                      {/* <img src={image &&  image.dataUrl} key={`picture-${index}`} className={previewImg} /> */}

                      {/* <img src={image &&  image.dataUrl} key={`picture-${index}`} alt="To see full report, please download the file" className={previewImg} /> */}
                      {/* <img src={image.dataUrl} key={`picture-${index}`} alt="preview" className={previewImg} /> */}

                      <ImgSingleViewer
                        openImgModal={openImgModal}
                        currentImg={currentImg}
                        onClose={() => setOpenImgModal(false)}
                      />

                    </Grid>
                  </Grid>
                )
            )
            }

          </DialogContent>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px',
    width: '100%',
    height: '100%',
  },
  visitInfo: {
    marginRight: '25px',
    '@media only screen and (max-width: 1024px)': {
      marginRight: '0',
      marginBottom: '25px',
    },
  },
  confirmationFields: {
    margin: '0 20px',
  },
  confirmationCardAppointmentSection: {
    paddingBottom: '34px',
  },
  confirmationCardAppointmentSectionTitle: {
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'uppercase',
    color: '#606A74',
    fontWeight: 'normal',
  },
  confirmationCardAppointmentSectionText: {
    color: '#1C2B39',
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '19px',
  },
  notes: {
    width: '100%',
  },
  previewImg: {
    maxWidth: '100%',
    maxHeight: 300,
    display:'block',
    margin: '1em 0'
  },
  btnSpacing: {
    marginBottom: '15px'
  },
  customFloatLeft: {
    width: '47%',
    display: 'inline-block',
    marginRight: '12px'
  },
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
},
});

export default withStyles(styles)(ApptReqPreview);
